export default __webpack_public_path__ + "static/media/gatoviy_otchet.6b8df509.jpeg";